import styled from 'styled-components'

const CardTitle = styled.div`
  color: #1a1a1a;
  padding: 12px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgb(230, 230, 230);
  margin-bottom: 12px;

  a {
    text-decoration: none;
    color: #1a1a1a;
    margin: 0;
  }

  h2 {
    font-size: 22px;
    font-weight: 600;
    margin: 0;
    color: #1a1a1a;
  }
`

export default CardTitle